import React__default from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CurationIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "18",
    viewBox: "0 0 20 18"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    fill: "#222",
    fillRule: "nonzero",
    d: "M5.333 17.667A1.34 1.34 0 0 1 4 16.318a1.34 1.34 0 0 1 1.333-1.348c.74 0 1.334.607 1.334 1.348a1.34 1.34 0 0 1-1.334 1.349zm0-1.334c-.003 0 0-.003 0-.015 0-.011-.003-.015 0-.015.004 0 0 .004 0 .015 0 .012.004.015 0 .015zm7.334 1.334a1.34 1.34 0 0 1-1.334-1.349 1.34 1.34 0 0 1 1.334-1.348c.74 0 1.333.607 1.333 1.348a1.34 1.34 0 0 1-1.333 1.349zm0-1.334c-.004 0 0-.003 0-.015 0-.011-.004-.015 0-.015.003 0 0 .004 0 .015 0 .012.003.015 0 .015zM2.12 3.364H0V2h3.213l.107.548.56 2.861h11.592l-.15.81-1.068 5.725c-.189.972-1.031 1.666-1.987 1.647H5.799c-.968.019-1.81-.675-2-1.646L2.12 3.364zm2.027 3.409l.96 4.906a.674.674 0 0 0 .68.548h6.492a.669.669 0 0 0 .666-.543l.916-4.911H4.147z"
  }), React__default.createElement("circle", {
    cx: "14",
    cy: "6",
    r: "6",
    fill: "#FFF"
  }), React__default.createElement("circle", {
    cx: "14",
    cy: "6",
    r: "5",
    fill: "#222"
  }), React__default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13.5 3h1v6h-1z"
  }), React__default.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11 6.5v-1h6v1z"
  })));
});

export default CurationIcon;
//# sourceMappingURL=curation.svg.js.map
